module.exports = __webpack_public_path__ + "img/LogoSportsCapital_Color.82d3739e.png";